import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { EditInputTarget } from '../../models';
import { UmmeldungEditInputsService } from '../../ummeldung-edit-inputs.service';

@Component({
  selector: 'ikp-ummeldung-edit-inputs-button',
  imports: [TranslatePipe],
  templateUrl: './edit-inputs-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditInputsButtonComponent {
  private readonly editInputsService = inject(UmmeldungEditInputsService);

  readonly dataTest = input.required<string>();
  readonly editInputTarget = input.required<EditInputTarget>();

  protected editInputs(): void {
    void this.editInputsService.editInputs(this.editInputTarget());
  }
}
